import { supportContact } from '../model/support-constants'

/**
 * Gatship contact details (phone, emails, office address) for the
 * support view and the user-settings Support panel.
 */
export function useSupportContactInfo() {
  return supportContact
}
